import {FormControl, InputLabel, Select, MenuItem} from '@mui/material';

function ChallengeList(props) {

    const challenges = props.items;

    const challengeList = challenges.map((challenge) =>
        <MenuItem key={challenge.id} value={challenge.id} className={props.selectedItem === challenge.id ? "selected" : "list-item"}>{challenge.label}</MenuItem>
    );

    if(props.loadingState){
        return (
            <></>
        )
    }else{
        return (
            <FormControl fullWidth>
                <InputLabel id="control-challenge-label">Challenge</InputLabel>
                <Select
                    labelId="control-challenge-label"
                    id="control-challenge-select"
                    label="Challenge"
                    value={props.selectedItem}
                    onChange={props.handleChange}
                    sx={{mb:2}}
                >
                    {challengeList}
                </Select>
            </FormControl>
        );
    }
  }
  

  export default ChallengeList;